const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const handleResponse = async (response) => {
  const data = await response.json();
  if (!response.ok || !data.success) {
    throw new Error(data.error || 'Kunde inte hantera AI-schema');
  }
  return data;
};

export const aiScheduleService = {
  getSchedules: async ({ userEmail } = {}) => {
    const response = await fetch(`${API_BASE_URL}/api/ai-schedules`, {
      headers: {
        ...(userEmail ? { 'x-user-email': userEmail } : {})
      }
    });
    const data = await handleResponse(response);
    return data.schedules || [];
  },
  createSchedule: async ({ schedule, userEmail }) => {
    const response = await fetch(`${API_BASE_URL}/api/ai-schedules`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(userEmail ? { 'x-user-email': userEmail } : {})
      },
      body: JSON.stringify(schedule)
    });
    const data = await handleResponse(response);
    return data.schedule;
  },
  updateSchedule: async ({ id, schedule, userEmail }) => {
    const response = await fetch(`${API_BASE_URL}/api/ai-schedules/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...(userEmail ? { 'x-user-email': userEmail } : {})
      },
      body: JSON.stringify(schedule)
    });
    const data = await handleResponse(response);
    return data.schedule;
  },
  deleteSchedule: async ({ id, userEmail }) => {
    const response = await fetch(`${API_BASE_URL}/api/ai-schedules/${id}`, {
      method: 'DELETE',
      headers: {
        ...(userEmail ? { 'x-user-email': userEmail } : {})
      }
    });
    await handleResponse(response);
    return true;
  },
  runSchedules: async ({ scheduleId, userEmail } = {}) => {
    const response = await fetch(`${API_BASE_URL}/api/ai-schedules/run`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(userEmail ? { 'x-user-email': userEmail } : {})
      },
      body: JSON.stringify({
        scheduleId: scheduleId || null
      })
    });
    const data = await handleResponse(response);
    return data;
  }
};
